import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'reactstrap'

export default function RefundConfirm({ handleConfirmRefund, isSubmittedRefund }) {
  return (
    <div>
      <div id="pendingRefundHtmlBlock" className="row-bot" style={{ display: 'block' }}>
        <p className="c-txt-18 text-center">
          <strong>Order has been refunded</strong><br />
          Have you received the refund payment?
        </p>
        <button
          className="btn btn--main"
          onClick={(e) => handleConfirmRefund(e)}
          disabled={isSubmittedRefund}
        >
          {isSubmittedRefund ? <Spinner color='light' size='sm' /> : 'Payment received'}
        </button>
      </div>
    </div>
  )
}

RefundConfirm.propTypes = {
  handleConfirmRefund: PropTypes.func,
  isSubmittedRefund: PropTypes.bool,
}
